import memberhubConstants from '~/constants/memberhub.constants'

export default function useStrongPasswordRequirementMessage (fallbackMessage = 'Must be a valid password.') {
  function getStrongPasswordRequirementMessage (unmetRequirements = []) {
    if (!Array.isArray(unmetRequirements) || !unmetRequirements.length) {
      return fallbackMessage
    }

    if (unmetRequirements.includes(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.UPPERCASE)) {
      return 'Almost there. Add an uppercase letter to continue.'
    }

    if (unmetRequirements.includes(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.LOWERCASE)) {
      return 'Almost there. Add a lowercase letter to continue.'
    }

    if (unmetRequirements.includes(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.NUMBER)) {
      return 'Almost there. Add a number to continue.'
    }

    if (unmetRequirements.includes(memberhubConstants.PASSWORD_METER_REQUIRED_KEYS.SPECIAL_CHAR)) {
      return 'Almost there. Add a special character to continue.'
    }

    return fallbackMessage
  }

  return {
    getStrongPasswordRequirementMessage
  }
}
